import React, { useEffect, useState } from 'react';
import { useForm, Controller } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from '@material-ui/icons/HighlightOff';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { EntryActions, NotificationActions } from '../../../store';


const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px'
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})


const merchantsSelector = (state) => state.Merchants;
const IdentitySelector = (state) => state.Identity;

const MerchantApplicationWithoutLogin = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const entryActions = bindActionCreators(EntryActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(merchantsSelector);
    const { token } = useSelector(IdentitySelector);

    const { control, errors, handleSubmit, watch ,register } = useForm();
    const { classes, data } = props;

    /**
     *
    * 戻るボタン押下
    *
    *
    */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 申込ボタン押下
     *
     *
     */
    const onEntry = () => {
        entryActions.entry(token, editing)
            .then(data => {
                // 登録メッセージ表示
                notificationActions.showSuccess('登録しました。');
                // 加盟店申込完了画面
                props.onComplete();
            })
            .catch(e => {
                notificationActions.showError(e.message);
            });
    }

    // 事業形態 
    var business_form = "";
    switch (editing.business_form)
    {
        case 1:
            business_form = <FormattedMessage id="Merchant.Corporate" />;
            break;
        case 2:
            business_form = <FormattedMessage id="Merchant.IndividualBusiness" />;
            break;
    }

    // 店舗識別コード種別
    var shop_cd_type = "";
    switch (editing.shop_cd_type) {
        case 1:
            shop_cd_type = <FormattedMessage id="Merchant.CorporateCodeTypeOkica" />;
            break;
        case 2:
            shop_cd_type = <FormattedMessage id="Merchant.CorporateCodeTypeJPQR" />;
            break;
    }
    
    return (
        <Container className={classes.root}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2}>   
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.ConfirmTitle" />}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.AppDesc"} /></InputLabel>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="Merchant.AppDetails" />}</Typography>
                        <Divider />
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.ContactName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_name}（{editing.contact_f_name}）</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.PhoneNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.contact_tel}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.MailAddress"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.mail_adress}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.BusinessForm"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{business_form}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_name}（{editing.corporat_f_name}）</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateNumber"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.corporat_no}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel1"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_1}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.StoreCodeLevel2"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.shop_cd_2}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.CorporateCodeType"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{shop_cd_type}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend"><FormattedMessage id={"Merchant.NameInEng"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_e_name}</InputLabel>
                    </Grid>
                  
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium"
                            startIcon={<ArrowBackIosIcon />}
                            onClick={onBackClick}><FormattedMessage id="Button.Back" /></Button>
                    </Grid>
                    <Grid item xs={6}>
                        <Button fullWidth variant="contained" size="medium" color="primary"
                            onClick={onEntry}>
                            <FormattedMessage id="Button.Apply" /></Button>
                    </Grid>
                </Grid>
            </Paper>
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(MerchantApplicationWithoutLogin);
